import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {filter, take, takeUntil} from 'rxjs/operators';
import {Observable, Subject} from 'rxjs';
import {Actions, ofActionCompleted, Select, Store} from '@ngxs/store';
import {Logout} from '@shared/state/auth/auth.actions';
import {AuthState} from '@shared/state/auth/auth.state';
import {ToastService} from '@app/service/util/toast.service';
import {AnalyticsService} from '@app/service/util/analytics.service';
import {PROFILE_DROPDOWN, RESEARCH_DROPDOWN} from './header-const';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';
import {AlertState} from '@shared/state/alert/alert.state';
import {GetAlerts, ResolveAlert} from '@shared/state/alert/alert.actions';
// import {MessagingService} from '@shared/service/messaging/messaging.service';
import {RoutingService} from '@app/service/routing/routing.service';
import {NavigationEnd} from '@angular/router';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  user: any;
  @Select(AuthState.getUserData) user$: Observable<any>;
  @Select(AuthState.getUserID) isAuth$: Observable<any>;
  @Select(AuthState.getIsAnonymous) isAnon$: Observable<boolean>;
  @Select(AlertState.getAlertData) alerts$: Observable<any>;

  searchVisible = false;
  isFolded = true;
  isExpand = false;
  // notificationList: Notification[] = [];
  colorMap = {
    debug: 'ant-avatar-cyan',
    info: 'ant-avatar-blue',
    success: 'ant-avatar-green',
    warning: 'ant-avatar-gold',
    error: 'ant-avatar-red'
  };
  iconMap = {
    billing: 'dollar'
  };

  isResolvingAlert = false;

  PROFILE_DROPDOWN = PROFILE_DROPDOWN;
  RESEARCH_DROPDOWN = RESEARCH_DROPDOWN;
  analyticsComponent = 'navbar';

  constructor(private store: Store, private toastr: ToastService, private themeService: ThemeConstantService,
              private cd: ChangeDetectorRef, private analytics: AnalyticsService, private actions: Actions,
              // private msgService: MessagingService,
              private routingService: RoutingService) {
  }

  ngOnInit() {
    // Listen for any new FCM messages
    // this.msgService.listen();
    // Set the user data based on the userInfo observable
    this.user$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(userData => {
        this.user = userData;
        // if (userData) {
        //   this.msgService.requestPermission(userData.userId);
        // }
      });
    this.themeService.isMenuFoldedChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isFolded => this.isFolded = isFolded);
    this.themeService.isExpandChanges
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe(isExpand => this.isExpand = isExpand);
    this.routingService.getRouterEvents()
      .pipe(
        filter(event => event instanceof NavigationEnd),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((event: NavigationEnd) => {
        return;
      });
  }

  // For side nav visibility, show the side nav if toggled
  toggleExpand() {
    this.isExpand = !this.isExpand; // Toggle the nav bar itself
    this.themeService.toggleExpand(this.isExpand);
    this.cd.detectChanges();
    this.cd.markForCheck();
  }

  searchToggle(): void {
    this.searchVisible = !this.searchVisible;
    this.analytics.trackUXMetric(this.analyticsComponent, 'search', 'click', 'success');
  }

  profileActions(action: string) {
    if (action === 'logout') {
      return this.logout();
    }
    return this.routingService.decodeAndNavigateToPath(action);
  }

  resolveAlert(item) {
    this.isResolvingAlert = true;

    this.actions.pipe(ofActionCompleted(ResolveAlert))
      .pipe(take(1))
      .subscribe(() => {
        this.isResolvingAlert = false;
        this.cd.markForCheck();
        this.analytics.trackUXMetric('alert', 'resolve', 'click', 'success');
      });
    this.store.dispatch(new ResolveAlert({alertId: item.id}));
  }

  openNotifications() {
    this.store.dispatch(new GetAlerts());
    const userId = this.store.selectSnapshot(AuthState.getUserID);
    // this.msgService.requestPermission(userId);
    this.analytics.trackUXMetric('alert', '', 'click', 'success');
  }

  navigateToSavedVehicles() {
    this.routingService.navigateToPath(['saved-vehicles']);
  }

  navigateToCreateReport() {
    this.routingService.navigateCreateReport();
  }

  navigateToLogin() {
    this.routingService.navigateLogin({
      redirectTo: this.routingService.getCurrentUrl()
    });
  }

  navigateToRegister() {
    this.routingService.navigateRegister({
      redirectTo: this.routingService.getCurrentUrl()
    });
  }

  logout() {
    this.store.dispatch(new Logout());
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
